import { AxiosError } from 'axios'

const errorResponseInterceptor = (error: AxiosError) => {
    if (
        error.response &&
        error.response.status <= 499 &&
        error.response.status >= 400 &&
        typeof error.response!.data !== 'string'
    ) {
        throw error
    } else {
        throw {
            ...(error || {}),
            response: {
                ...(error.response || {}),
                data: {
                    ...(error.response?.data || {}),
                    error: {
                        code: error.response?.status,
                        message: 'Something went wrong',
                    },
                },
            },
        }
    }
}

export { errorResponseInterceptor }
